import {getElementByTagName} from '../utils';
import config from '../../config';

const createAnchor = (hash) => {
    const main = getElementByTagName('main');

    for (let item of Array.from(main.childNodes)) {
        if (item.classList.contains('anchor')) {
            return
        }
    }

    config.forEach((c) => {
        const anchor = document.createElement('a');
        anchor.classList.add('anchor');
        anchor.id = c.link;
        anchor.name = c.link;

        main.append(anchor);
    })

};

export default createAnchor;
